// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"fb4a6a2c","963":"c3242960","977":"8d867a60"}[chunkId] + ".chunk.js";
};